<script lang="ts" setup>
import enIcon from '@images/lang/en2.png'
import idIcon from '@images/lang/id.png'

const { locale, locales, setLocale } = useI18n()

const changeLanguage = async lang => {
    await setLocale(lang)
    reloadNuxtApp()
}
</script>

<template>
  <div class="cursor-pointer" role="button" tabindex="0">
    <div class="">
      <VAvatar size="38">
        <VImg
          :src="locale === 'en' ? enIcon : idIcon"
          :alt="`${locale} language flag`"
        />
      </VAvatar>
    </div>
    <VMenu
      activator="parent"
      location="bottom end"
      offset="15px 15px"
      width="100px"
    >
      <VList>
        <VListItem
          v-for="lang in locales"
          :key="lang.code"
          class="text-uppercase"
          @click="changeLanguage(lang.code)"
        >
          <VAvatar
            size="38"
            class="flex-1-0"
          >
            <VImg
              :src="lang.code === 'en' ? enIcon : idIcon"
              :alt="`${lang.code} language flag`"
            />
          </VAvatar>
          {{ lang.code }}
        </VListItem>
      </VList>
    </VMenu>
  </div>
</template>

<style lang="scss"></style>
